var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DxTabPanel',{scopedSlots:_vm._u([{key:"dashboar-report-xlsx-tab",fn:function(){return [_c('DownloadReportXslx')]},proxy:true}])},[_c('DxItem',{attrs:{"title":"Reporte XSXL","template":"dashboar-report-xlsx-tab"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }